import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

import { ConfirmationService } from 'primeng/primeng';
import { InscricaoService } from './../../../services/inscricao.service';

import { Endereco } from './../../../models/endereco';

import { CustomValidator } from '../../shared/validators/custom.validator';
import { Observable } from 'rxjs/Observable';
import { Util } from '../../shared/util';

import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { UnidadeService } from '../../shared/services/unidade.service';
import { CandidatoService } from '../candidato.service';
import { Usuario } from '../../../models/usuario';
import { AuthService } from '../../admin/auth.service';
import { Perfis } from '../../../models/perfis';

@Component({
  templateUrl: './inscricao-edit-form.component.html',
})
export class InscricaoEditFormComponent extends WebPage implements OnInit {

  comoConheceus;
  deficiencias;
  escolaridades;
  estadosCivis;
  racaCores;
  ufs;
  unidades;

  unidade;
  endereco = new Endereco();

  isSubmitted = false;
  errorMessage: string;
  usuario: Usuario;

  idCandidato;
  candidato;

  get ConfirmeEmail() { return this.form.get('ConfirmeEmail'); }
  get Cep() { return this.form.get('Cep'); }
  get dataCnh() { return this.form.get('dataCnh'); }

  public form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private inscricaoService: InscricaoService,
    private unidadeService: UnidadeService,
    private candidatoService: CandidatoService,
    private authService: AuthService,
  ) {
    super(messageService);
    this.usuario = this.authService.informacoesUsuario();
    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );

    this.form = this.fb.group({
      idCandidato: [],
      idFase: [],
      Cpf: [],
      Nome: [null, [ Validators.maxLength(200), Validators.required ]],
      dataNascimento: [],
      Sexo: [null, Validators.required],
      nomePai: [null, [ Validators.maxLength(200), Validators.required ]],
      nomeMae: [null, [ Validators.maxLength(200), Validators.required ]],
      IdUnidade: [],
      Unidade: [],
      Rg: [null, [ Validators.maxLength(50), Validators.required ]],
      Orgao: [null, [ Validators.maxLength(100), Validators.required ]],
      IdUfOrgao: [null, Validators.required],
      Nacionalidade: [null, [ Validators.maxLength(200), Validators.required ]],
      Naturalidade: [null, [ Validators.maxLength(200), Validators.required ]],
      IdRacaCor: [null, Validators.required],
      IdEstadoCivil: [null, Validators.required],
      IdEscolaridade: [null, Validators.required],
      RendaIndividual: [],
      SituacaoEmpregaticia: ['Empregado'],
      IdComoConheceu: [null, Validators.required],
      Observacao: [null, Validators.maxLength(500)],
      Cnpj: [],
      RazaoSocial: [],
      Ocupacao: ['Empregado'],
      TelefonePreferencial: [null, Validators.required],
      TelefoneOpcional1: [],
      TelefoneOpcional2: [],
      Email: [null, [ Validators.minLength(5), Validators.maxLength(200), Validators.required, CustomValidator.EmailValidator ]],
      ConfirmeEmail: [null, [ Validators.minLength(5), Validators.maxLength(200), Validators.required, CustomValidator.EmailValidator ]],
      Cep: [null, [ Validators.minLength(10), Validators.required ]],
      Logradouro: [null, [ Validators.maxLength(200), Validators.required ]],
      Numero: [null, [ Validators.maxLength(50), Validators.required ]],
      Complemento: [],
      Bairro: [null, [ Validators.maxLength(200), Validators.required ]],
      Cidade: [],
      Uf: [],
      NumeroCnh: [null, [ Validators.maxLength(50), Validators.required ]],
      dataCnh: [null, Validators.required],
      validadeCnh: [null, Validators.required],
      IdCategoriaAtual: [null, Validators.required],
      IdCategoriaPretendida: [null, Validators.required],
      IdDeficiencia: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.isLoading = true;
    Observable.combineLatest(
      this.unidadeService.getListaUf(),
      this.inscricaoService.getListaRacacor(),
      this.inscricaoService.getListaEstadocivil(),
      this.inscricaoService.getListaEscolaridade(),
      this.inscricaoService.getListaComoconheceu(),
      this.inscricaoService.getListaDeficiencia(),
      this.candidatoService.getFull(this.idCandidato)
    )
    .finally(() => this.isLoading = false)
    .subscribe(
      combined => {
        this.ufs = combined[0];
        this.racaCores = combined[1];
        this.estadosCivis = combined[2];
        this.escolaridades = combined[3];
        this.comoConheceus = combined[4];
        this.deficiencias = combined[5];
        this.candidato = combined[6];
        console.log(this.candidato);
        this.form.patchValue({
          idCandidato: this.candidato.idCandidato,
          idFase: this.candidato.idFase,
          Cpf: Util.formatAsCpf(this.candidato.cpf),
          Nome: this.candidato.nome,
          dataNascimento: new Date(this.candidato.dataNascimento).toLocaleDateString(),
          Sexo: this.candidato.sexo,
          nomePai: this.candidato.nomePai,
          nomeMae: this.candidato.nomeMae,
          IdUnidade: this.candidato.idUnidade,
          Unidade: this.candidato.unidade.nomeUnidade,
          Rg: this.candidato.rg,
          Orgao: this.candidato.orgao,
          IdUfOrgao: this.candidato.idUfOrgao,
          Nacionalidade: this.candidato.nacionalidade,
          Naturalidade: this.candidato.naturalidade,
          IdRacaCor: this.candidato.idRacaCor,
          IdEstadoCivil: this.candidato.idEstadoCivil,
          IdEscolaridade: this.candidato.idEscolaridade,
          RendaIndividual: this.candidato.rendaIndividual,
          IdComoConheceu: this.candidato.idComoConheceu,
          Observacao: this.candidato.observacao,
          Cnpj: Util.formatAsCnpj(this.candidato.cnpj),
          RazaoSocial: this.candidato.razaoSocial,
          TelefonePreferencial: this.candidato.telefonePreferencial,
          TelefoneOpcional1: this.candidato.telefoneOpcional1,
          TelefoneOpcional2: this.candidato.telefoneOpcional2,
          Email: this.candidato.email,
          ConfirmeEmail: this.candidato.confirmeEmail,
          Cep: this.candidato.cep,
          Logradouro: this.candidato.logradouro,
          Numero: this.candidato.numero,
          Complemento: this.candidato.complemento,
          Bairro: this.candidato.bairro,
          Cidade: this.candidato.cidade,
          Uf: this.candidato.uf,
          NumeroCnh: this.candidato.numeroCnh,
          dataCnh: new Date(this.candidato.dataCnh).toLocaleDateString(),
          validadeCnh: new Date(this.candidato.validadeCnh).toLocaleDateString(),
          IdCategoriaAtual: this.candidato.idCategoriaAtual,
          IdCategoriaPretendida: this.candidato.idCategoriaPretendida,
          IdDeficiencia: this.candidato.idDeficiencia,
        });
      },
      error => this.gerenciaErro(error)
    );
  }

  private validaEmail() {
    if (this.form.get('Email').value !== this.ConfirmeEmail.value) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'E-mail de confirmação deve ser o mesmo do campo de Email.'
      });
      this.ConfirmeEmail.setValue('');
    }
  }

  getEnderecoByCep() {
    this.endereco.cidade = '';
    this.endereco.logradouro = '';
    this.endereco.bairro = '';
    this.endereco.uf = '';

    this.isLoading = true;
    this.inscricaoService.getEnderecoByCep(Util.limpaCep(this.Cep.value), this.candidato.unidade.idUf)
      .finally(() => this.isLoading = false)
      .subscribe (
        data => {
          // if (data === 'invalido') {
          //   this.messageService.add({
          //     severity: 'warn',
          //     summary: 'Atenção',
          //     detail: 'O CEP deve ser da mesma UF da Unidade Operacional!'
          //   });
          //   this.Cep.setValue('');
          // } else {
            this.endereco = new Endereco(data);
            this.form.patchValue({
              Cidade: this.endereco.cidade,
              Logradouro: this.endereco.logradouro,
              Bairro: this.endereco.bairro,
              Uf: this.endereco.uf
            });
          // }
        },
        error => this.gerenciaErro(error)
      );
  }

  validaCnh() {
    const dataEmissao = this.form.get('dataCnh').value;
    const categoriaAtual = this.getCategoriaAtualTexto();
    const categoriaPretendida = this.getCategoriaPretendidaTexto();

    // Se não há categoria pretendida selecionada, não faz validação
    if (!categoriaPretendida || categoriaAtual === categoriaPretendida) {
      return;
    }

    // Converte a data do formato dd/MM/yyyy para yyyy-MM-dd
    const dataEmissaoFormatada = this.converterDataParaISO(dataEmissao);

    console.log('data Emissao', dataEmissao)
    console.log('data Emissao Formatada', dataEmissaoFormatada)
    console.log('categoria Atual', categoriaAtual)
    console.log('categoria Pretendida', categoriaPretendida)
    // Valida usando o utilitário local
    const isValido = Util.validaCnhProgressaoCategoria(dataEmissaoFormatada, categoriaAtual, categoriaPretendida);

    if (!isValido) {
      this.messageService.add({
        severity: "warn",
        summary: "Atenção",
        detail: "O candidato não possui o tempo mínimo de habilitação exigida pelo Contran para a categoria pretendida.",
      });
      // Limpa a categoria pretendida em vez da data
      this.form.get('IdCategoriaPretendida').setValue('');
    }
  }

  private converterDataParaISO(data: string): string {
    if (!data || data.length !== 10) {
      return '';
    }
    
    // Converte de dd/MM/yyyy para yyyy-MM-dd
    const partes = data.split('/');
    if (partes.length !== 3) {
      return '';
    }
    
    const dia = partes[0];
    const mes = partes[1];
    const ano = partes[2];
    
    return `${ano}-${mes}-${dia}`;
  }

  private getCategoriaAtualTexto(): string {
    const formControl = this.form.get('IdCategoriaAtual');
    const idCategoriaAtual = formControl ? formControl.value : null;
    const categoriaMap = {
      '4b3b98b5-6dda-492e-afbd-fbaab06e01e2': 'B',
      '3db0cf4c-8156-4fbc-b0a0-5fdade55027c': 'C',
      '3dc4fd04-a088-486a-8f45-f85b6d7f96b3': 'D'
    };
    return categoriaMap[idCategoriaAtual] || '';
  }

  private getCategoriaPretendidaTexto(): string {
    const formControl = this.form.get('IdCategoriaPretendida');
    const idCategoriaPretendida = formControl ? formControl.value : null;
    const categoriaMap = {
      '3db0cf4c-8156-4fbc-b0a0-5fdade55027c': 'C',
      '3dc4fd04-a088-486a-8f45-f85b6d7f96b3': 'D',
      '6c388665-75f3-44d0-ad2c-301f76e51b0b': 'E'
    };
    return categoriaMap[idCategoriaPretendida] || '';
  }

  submit() {
    this.isSubmitted = true;

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campo obrigatório não preenchido!' });
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja enviar os dados digitados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.inscricaoService.editarCandidato(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe (
            () => this.router.navigate(['/gerenciar-etapas']),
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => this.router.navigate(['/gerenciar-etapas'])
    });
  }

  podeMostrarCampos() {

 if (
      this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex
    ) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/candidato/inscricao-edit-form/inscricao-edit-form.component.ts